import { LitElement, html } from 'lit';
import { property, customElement } from 'lit/decorators.js';
import { styles } from '../view/styles';
import { WEB_COMPONENT_UNSET_VMWARE_INTEGRATOR } from '../../../../../webcomponents.constants';
import { translateFn } from '../../../../../utils/translator.helper';
import { FontSizes } from '../../../../../types/common/types';

/**
 * @summary Type here the description of this component
 * @tag unset-vmware-integrator
 * Here https://custom-elements-manifest.open-wc.org/analyzer/getting-started/ you can find out how to document the code
 */
@customElement(WEB_COMPONENT_UNSET_VMWARE_INTEGRATOR)
export class UnsetVmwareIntegratorWebComponent extends LitElement {
  /**
   * See https://lit-element.polymer-project.org/guide/properties
   * Write here the description of this field
   */
  @property({ type: String, attribute: true, reflect: true })
  message = '';

  static get styles() {
    return styles;
  }

  render() {
    return html`
      <gz-text
        fontSize="${FontSizes.HEADING_6}"
        .innerHTML= ${this.message}>
      </gz-text>
    `;
  }

  constructor() {
    super();
    this.message = translateFn('Are you sure you want to unassign this endpoint as an integrator? {break} This will stop the vCenter inventory synchronization.',
      { break: '<br>' }
    );
  }
}

declare global {
  interface HTMLElementTagNameMap {
    'unset-vmware-integrator': UnsetVmwareIntegratorWebComponent;
  }
}
